import requiredParam from './requiredParam';
import setStateOnChange, { getEventValue } from './setStateOnChange';
import * as array from './array';
import splitCamelCase from './splitCamelCase';
import handleChange from './handleChange';
import objectToPropType from './objectToPropType';
import stylesToPropType from './stylesToPropType';
import copyToClipboard from './copyToClipboard';
import hideAfterAnimate from './hideAfterAnimate';
import capitalize from './capitalize';
import isUrl from './isUrl';
import * as validations from './validations';
import debounce from './debounce';
import parseQueryString from './parseQueryString';
import formatDefaultDate from './defaultDateFormat';

export {
  array,
  requiredParam,
  setStateOnChange,
  getEventValue,
  splitCamelCase,
  handleChange,
  objectToPropType,
  stylesToPropType,
  copyToClipboard,
  hideAfterAnimate,
  capitalize,
  isUrl,
  validations,
  debounce,
  parseQueryString,
  formatDefaultDate,
};

export default {
  array,
  requiredParam,
  setStateOnChange,
  getEventValue,
  splitCamelCase,
  handleChange,
  objectToPropType,
  stylesToPropType,
  copyToClipboard,
  hideAfterAnimate,
  capitalize,
  isUrl,
  validations,
  debounce,
  parseQueryString,
  formatDefaultDate,
};
